import React, { Component } from 'react';
import Siema from 'siema';
import Img from 'gatsby-image';

import styles from '@styles/carousel.module.css';
import { cx } from '@utils';

export default class Carousel extends Component {
  componentDidMount() {
    this.siema = new Siema({
      selector: `.${this.props.name}-siema`,
      loop: true,
    });
  }

  prev = () => this.siema.prev();
  next = () => this.siema.next();

  renderImages = () => {
    const { images, altText = '' } = this.props;
    const len = images.length;

    return images.map((img, i) => {
      const prevImg = images[(i + len - 1) % len];
      const nextImg = images[(i + 1) % len];

      return (
        <div className={cx('row', styles.imgWrapper)} key={`slika-${i}`}>
          <div className={cx('col-lg-2 d-none d-lg-block', styles.imgSide)}>
            <Img
              fluid={prevImg.fluid}
              alt={altText}
              style={{ height: '100%' }}
              imgStyle={{ objectPosition: 'right top' }}
            />
          </div>
          <div className="col-md-10 col-lg-7">
            <Img
              fluid={img.fluid}
              alt={altText}
              style={{ height: '100%' }}
            />
          </div>
          <div className={cx('col-md-2 col-lg-3 d-none d-md-block', styles.imgSide)}>
            <Img
              fluid={nextImg.fluid}
              alt={altText}
              style={{ height: '100%' }}
              imgStyle={{ objectPosition: 'left top' }}
            />
          </div>
        </div>
      );
    });
  };

  render() {
    const { name, title, description, location, time, navPosition } = this.props;

    return (
      <>
        <div className="position-relative row">
          {title && (
            <div className="col-12">
              <h3>{title}</h3>
            </div>
          )}

          {description && (
            <div className="col-12 col-md-10 pb-3">
              <p>{description}</p>
            </div>
          )}

          <div className={description ? 'col-10 col-md-12' : 'col-12'}>
            <div className="informations">
              {location && (
                <span className={styles.dataPill}>
                  <span className="icon-location"></span>
                  {location}
                </span>
              )}
              {time && (
                <span className={styles.dataPill}>
                  <span className="icon-time"></span>
                  {time}
                </span>
              )}
            </div>
          </div>

          <div className={cx(styles.navigationButtons, navPosition === 'bottom' && styles.navigationButtonsBottom)}>
            <button onClick={this.prev} aria-label="Prethodna slika">
              <span className="icon-arrow-left"></span>
            </button>
            <button onClick={this.next} aria-label="Sljedeća slika">
              <span className="icon-arrow-right"></span>
            </button>
          </div>
        </div>

        <div className={cx(`${name}-siema`, styles.carousel)}>
          {this.renderImages()}
        </div>
      </>
    );
  }
}
